import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { loginUrl, UserInfoUrl, RegisterUrl } from '../../shared/constants';
import axios from 'axios';
import {
  LOGIN_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  CHECK_USER,
  REGISTER_USER,

} from '../contants';

import {
  loginUserSuccess,
  loginUserError,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPasswordSuccess,
  resetPasswordError,
  CheckSuccess,
  CheckUserError,
  registerUserSuccess,
  registerUserError,
} from './actions';

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

export function* watchCheckUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(CHECK_USER, checkWithNoParams);
}

export function* watchRegisterUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(REGISTER_USER, register);
}

const loginWithEmailPasswordAsync = async (email, password) => {
  return axios
    .post(loginUrl, { email, password })
    .then((res) => {
      const loginUser = {};
      if (res.data.status) {
        loginUser.message = false;
        loginUser.token = res.data.token;
      } else {
        loginUser.message = res.data.code;
      }
      return loginUser;
    })
    .catch((err) => {
      console.log(err);
      const loginUser = {};
      loginUser.message = 'login_fail';
      return loginUser;
    });
};

function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { navigate } = payload;
  try {
    const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
    if (!loginUser.message) {
      localStorage.setItem("userToken", loginUser.token)
      
      yield put(loginUserSuccess());
      navigate('/home')
      yield call(LoginCheckAsync, loginUser.token); //로그인 후 로그인체크

    } else {
      yield put(loginUserError(loginUser.message));
    }
  } catch (error) {
    console.log(error);
    yield put(loginUserError(error));
  }
}

const registerWithEmailPasswordAsync = async (user ) => {
  
  return axios
    .post(RegisterUrl, user)
    .then((res) => {
      const User = { loaded : false, email : '', token : '', message : '' };
      if (res.data.status) {
        User.loaded = true;
      } else {
        User.loaded = false;
        User.message = res.data.code;
      }
      return User;
    })
    .catch((err) => {
      console.log(err);
      const User = { loaded : true, message : '', token : '' };
      User.message = 'REGISTER FAIL';
      return User;
    });
};

function* register({payload}) {
  
  const { navigate } = payload;
  const { user } = payload;

  try {
    const User = yield call(registerWithEmailPasswordAsync, user);
    if (User.loaded) {
      //const item = { email : User.email , token: User.token  };
      yield put(registerUserSuccess());
      navigate('/login')
    } else {

      yield put(registerUserError(User.message));
    }
  } catch (error) {
    console.log(error);
    yield put(registerUserError(error));
  }
}

function* checkWithNoParams() {
  try {
    const checkUser = yield call(LoginCheckAsync);
    if (!checkUser.message) {
      yield put(CheckSuccess(checkUser.assets, checkUser.user));
    } else {
      yield put(CheckUserError(checkUser.message));
    }
  } catch (error) {
    console.log(error);
    yield put(CheckUserError(error));
  }
}

const LoginCheckAsync = async () => {
  const senddata = { token_type : 'MDTI' };
  const token = localStorage.getItem('userToken');
  return axios
    .post(UserInfoUrl , senddata, { headers: { Authorization: `Bearer ${token}` } } )
    .then((res) => {
      return {assets : res.data.assets, user : res.data.user}
    })
    .catch((err) => {
      console.log(err);
      const User = { loaded : false};
      return User;
    });
};


export function* watchLogoutUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async ( navigate ) => {
};

function* logout({ payload }) {
  const { navigate } = payload;
  localStorage.removeItem('userToken');
  navigate('/login')
  yield call(logoutAsync, navigate);
}

export function* watchForgotPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
  // eslint-disable-next-line no-return-await
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    if (!forgotPasswordStatus) {
      yield put(forgotPasswordSuccess('success'));
    } else {
      yield put(forgotPasswordError(forgotPasswordStatus.message));
    }
  } catch (error) {
    yield put(forgotPasswordError(error));
  }
}

export function* watchResetPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  // eslint-disable-next-line no-return-await
};

function* resetPassword({ payload }) {
  const { newPassword, resetPasswordCode } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword
    );
    if (!resetPasswordStatus) {
      yield put(resetPasswordSuccess('success'));
    } else {
      yield put(resetPasswordError(resetPasswordStatus.message));
    }
  } catch (error) {
    yield put(resetPasswordError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchCheckUser),
    fork(watchRegisterUser),
    fork(watchLogoutUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
